import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {AppService} from 'src/app/app.service';
import {filter} from 'rxjs/operators';
import {NavigationEnd, Router} from '@angular/router';
import {Constants} from 'src/app/shared/utils/constants';
import {LanguageSelectionComponent} from 'src/app/shared/components/language-selection/language-selection.component';
import {TranslateService} from '@ngx-translate/core';

declare var $: any;

@Component({
  selector: 'fx-aside',
  templateUrl: './aside.component.html',
  styleUrls: ['./aside.component.sass'],
})
export class AsideComponent implements OnInit {
  @ViewChild('languageSelection')
  public languageSelection: LanguageSelectionComponent;
  @Output() navClick = new EventEmitter();
  @Output() drawerClick = new EventEmitter();
  activeUrl = '';
  menu: any[] = [];
  user: any = {};
  constructor(
    private router: Router,
    appService: AppService,
    public translate: TranslateService,
  ) {
    router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.activeUrl = window.location.pathname;
      });
    this.menu = appService.buildMenu(Constants.MENU);
    this.user = JSON.parse(localStorage.getItem('USER_LOGGED'));
  }

  ngOnInit(): void {}

  expandMenu(menuItem?: any): void {
    this.navClick.emit(menuItem);
  }

  logout(): void {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('permission');
    localStorage.removeItem('USER_LOGGED');
    this.router.navigate(['/auth/signin']);
  }
}
